import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-154f103c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__transcription" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Redefinição de senha"),
  /*#__PURE__*/_createElementVNode("p", { class: "form__description" }, " A senha deve conter no mínimo 8 caracteres. ")
], -1))
const _hoisted_2 = { class: "form__containers" }
const _hoisted_3 = { class: "form__containers__box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form__containers__input",
  class: "form__containers__label"
}, "Mostrar senha", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  form: "new-password",
  class: "form__input form__input--submit",
  type: "submit",
  value: "Alterar"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_password = _resolveComponent("input-password")!
  const _component_modern_input = _resolveComponent("modern-input")!

  return (_openBlock(), _createElementBlock("form", {
    id: "new-password",
    class: "form",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.resetPassword && $setup.resetPassword(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_input_password, {
        form: "new-password",
        required: "",
        "model-value": $setup.password,
        "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
        id: "input-new-password",
        label: "Senha",
        typeInput: $setup.currentType,
        "input-color": "var(--color-black-dark)"
      }, null, 8, ["model-value", "typeInput"]),
      _createVNode(_component_modern_input, {
        form: "new-password",
        type: $setup.currentType,
        id: "confirmation-password",
        label: "Confirmar senha",
        "user-data": $setup.confirmation,
        "onUpdate:user-data": _cache[1] || (_cache[1] = ($event: any) => (($setup.confirmation) = $event)),
        required: "",
        color: "var(--color-black-dark)"
      }, null, 8, ["type", "user-data"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          form: "new-password",
          onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.togglePasswordVisibility($event.target.checked))),
          type: "checkbox",
          id: "form__containers__input",
          class: "form__containers__input"
        }, null, 32),
        _hoisted_4
      ])
    ]),
    _hoisted_5
  ], 32))
}